// extracted by mini-css-extract-plugin
export var brand = "_64-9";
export var compact = "_64-6";
export var extraSmall = "_64-7";
export var icon = "_64-0";
export var large = "_64-4";
export var light = "_64-1";
export var medium = "_64-5";
export var outline = "_64-b";
export var primaryDark = "_64-a";
export var primaryLight = "_64-8";
export var primaryModern = "_64-c";
export var success = "_64-2";
export var successSolid = "_64-3";